import React from 'react';
import {OneImageOrganicGridWithContent} from '@components/OrganicImageGrid/';
import {useContainerSize} from '@components/layout';
import {ThemeProvider} from '@styles';

export default function OneImageWithContentSection({...props}): JSX.Element {
  const {wide} = useContainerSize();
  return (
    <ThemeProvider
      theme={
        props.theme
          ? Object.assign(
              {
                maxWidth: wide ? '80%' : '100%',
              },
              props.theme,
            )
          : {
              maxWidth: wide ? '80%' : '100%',
            }
      }
    >
      <OneImageOrganicGridWithContent {...props} />
    </ThemeProvider>
  );
}
